import React from "react";
import { MetaPixel } from "./components/MetaPixel";
import { Hero } from "./components/sections/Hero";
import { Intro } from "./components/sections/Intro";
import { BeforeAfter } from "./components/sections/BeforeAfter";
import { Challenges } from "./components/sections/Challenges";
import { Volumes } from "./components/sections/Volumes";
import { Bonuses } from "./components/sections/Bonuses";
import { ValueStack } from "./components/sections/ValueStack";
import { SpecialOffer } from "./components/sections/SpecialOffer";
import { Decision } from "./components/sections/Decision";
import { Testimonials } from "./components/sections/Testimonials";
import { Author } from "./components/sections/Author";
import { Faq } from "./components/sections/Faq";
import { FinalCta } from "./components/sections/FinalCta";
import { Footer } from "./components/sections/Footer";
import { FloatingCta } from "./components/FloatingCta";
import { PurchasePopup } from "./components/PurchasePopup";
export function App() {
  return <div className="min-h-screen w-full overflow-x-hidden bg-white" data-id="element-0" data-mp="3ij668fcdfvai">
      <MetaPixel data-id="element-1" data-mp="3ml12h5fg3ihf" />
      <Hero data-id="element-2" data-mp="3mkho1yp07c85" />
      <main data-id="element-3" data-mp="3mjzsl4a6121a">
        <Intro data-id="element-4" data-mp="3mjq3rk0ux0x6" />
        <BeforeAfter data-id="element-5" data-mp="3mj6jvxrnc2gi" />
        <Challenges data-id="element-6" data-mp="3rcj31sdk3h1v" />
        <Volumes data-id="element-7" data-mp="3rdaquh0wwahl" />
        <Bonuses data-id="element-8" data-mp="3rcsy3udgkeef" />
        <ValueStack data-id="element-9" data-mp="3recf5n6xuth9" />
        <SpecialOffer data-id="element-10" data-mp="5yimri0b7dt" />
        <Decision data-id="element-11" data-mp="6htjo98ovic" />
        <Testimonials data-id="element-12" data-mp="4n4bxqxqh8g" />
        <Author data-id="element-13" data-mp="56m9egl55mh" />
        <Faq data-id="element-14" data-mp="7ssnarqpf34" />
        <FinalCta data-id="element-15" data-mp="2zld1d7i6tbah" />
      </main>
      <Footer data-id="element-16" data-mp="2zm4zaoz9bl3x" />
      <FloatingCta data-id="element-17" data-mp="2zmo4r67q0h12" />
      <PurchasePopup data-id="element-18" data-mp="2zn6aquk6q9m6" />
    </div>;
}